import { CnaeImpedidoService } from './../cnae-impedido.service';
import { MascaraCnaeImpedido } from './../../../model/mascara-cnae-impedido.model';
import { ObjetivosFinanciamento } from "src/app/model/objetivo-financiamento.model";
import { Component, Injector, OnInit, ViewChild, TemplateRef,HostListener } from '@angular/core';
import { Tranche } from 'src/app/model/tranche.model';
import { TrancheService } from 'src/app/shared/services/tranche.service';
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { PermissaoService } from 'src/app/shared/permissao.service';
import { ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { MessageChannelService, messageLevel, BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { TiposOperacao } from 'src/app/model/modalidade_garantia.model';
import { DatePipe } from '@angular/common';
import { TipoOperacao, TipoOperacaoEnum } from 'src/app/model/tipo-operacao-enum';
import { EntityPagedResult } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ExportService } from "../export.service";
import { Situacao, SituacaoEnum } from 'src/app/model/situacao-enum';


@Component({
    selector: 'app-cnae-impedido-pesquisa',
    templateUrl: './cnae-impedido-pesquisa.component.html',
    styleUrls: ['./cnae-impedido-pesquisa.component.scss'],
    standalone: false
})
export class CnaeImpedidoPesquisaComponent implements OnInit {

  public cnaeImpedido: MascaraCnaeImpedido[] = [];
  public tranches: Tranche[] = [];
  public ideTranche: number;
  public pesquisado: boolean = false;
  public esconderPesquisa: boolean = true;
  public podeCadastrar: boolean;
  public permissaoEdicao: boolean;
  public mascara: string;
  public dataInicioValidadeImpedimento: Date;
  public codigoTipoOperacao: string;
  public codigoModalidadeOperacao: string;
  public labelsOperacao = TiposOperacao;
  public objetivosFinanciamento = ObjetivosFinanciamento;
  public mensagemAviso: string = "";
  public filtroCnaeImpedido: boolean = false;
  public dataInicio: Date;
  public dataFim: Date;
  public tipoOperacao: string;
  public situacao: string;
  tiposOperacoes: TipoOperacao[] = [
    {
      nome: 'L - Crédito Livre',
      valor: TipoOperacaoEnum.CREDITO,
    },
    {
      nome: 'R - Repasse BNDES',
      valor: TipoOperacaoEnum.REPASSE,
    }
  ];
  situacoes: Situacao[] = [
    {
      nome: 'Ativos',
      valor: SituacaoEnum.ATIVOS,
    },
    {
      nome: 'Inativos',
      valor: SituacaoEnum.INATIVOS,
    }
  ];
  atributosPaginacaoComponenteListagem: EntityPagedResult<MascaraCnaeImpedido>;
  public opcoesPaginacao: number[];

  @ViewChild('botoes') botoesPersonalizados: TemplateRef<any>;
  @ViewChild('body') msgPersonalizada: TemplateRef<any>;

  constructor(private trancheService: TrancheService,
    private bnLoadingService: BnLoadingService,
    private cnaeService: CnaeImpedidoService,
    private permissaoService: PermissaoService,
    private modalService: BnModalMessageService,
    protected injector: Injector,
    public service: CnaeImpedidoService,
    private messageService: MessageChannelService,
    private datePipe: DatePipe,
    private exportService: ExportService,) {

  }

  @HostListener('window:keydown.enter', ['$event'])
  keyEvent(event: KeyboardEvent) {
    this.buscarTodos(false)
  }

  ngOnInit(): void {
    this.opcoesPaginacao = [10, 20, 30];
    this.atributosPaginacaoComponenteListagem = {
      page: 1,
      pageSize: this.opcoesPaginacao[0],
      pages: undefined,
      count: undefined,
      list: undefined
    };
    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe(resp => {
      this.permissaoEdicao = resp[ROLE_GESTOR_ENVIO];
      this.podeCadastrar = resp && resp[ROLE_GESTOR_ENVIO];
    })
    this.trancheService.getTranches().subscribe(tranches => {
      this.tranches = tranches;
    });
  }

  mudancaPagina(novaPagina: EntityPagedResult<MascaraCnaeImpedido>) {
    this.atributosPaginacaoComponenteListagem = novaPagina;
    this.buscarTodos(true);
  }

  public buscarTodos(paginado: boolean) {
    this.bnLoadingService.bloqueiaTela();
    const dto = this.tratarInformacoesPreenchidas();
    dto.pagina = paginado ? this.atributosPaginacaoComponenteListagem.page : 1;
    dto.limite = this.atributosPaginacaoComponenteListagem.pageSize;
    
    if (this.ideTranche) {
      this.esconderPesquisa = true;
      this.cnaeService.buscarTodosComFiltro(this.ideTranche, dto).subscribe
        ((cnae: any) => {
          this.cnaeImpedido = cnae.resultados;
          this.atributosPaginacaoComponenteListagem.count = cnae ?
            cnae.totalRegistrosSemPaginacao : 0;
          this.pesquisado = true;
          this.esconderPesquisa = false;
        })
    }
    this.bnLoadingService.liberaTela();
  }

  tratarInformacoesPreenchidas() {
    let dto: any = {};

    if(this.dataInicio) {
      dto.dataInicioValidade = this.datePipe.transform(this.dataInicio, 'yyyyMMdd');
    }
    if(this.dataFim) {
      dto.dataFimValidade = this.datePipe.transform(this.dataFim, 'yyyyMMdd');
    }
    if(this.tipoOperacao) {
      dto.tipoOperacao = this.tipoOperacao;
    }
    if(this.situacao) {
      dto.situacao = this.situacao;
    }
    return dto;
  }

  public limpar() {
    this.atributosPaginacaoComponenteListagem.page = 1;
    this.ideTranche = null;
    this.tipoOperacao = null;
    this.situacao = null;
    this.dataInicio = null;
    this.dataFim = null;
    this.pesquisado = false;
  } 

  public salvar() {
    let dto: MascaraCnaeImpedido = {} as MascaraCnaeImpedido
    if (this.mascara) {
      dto.mascara = this.mascara
    }
    if (this.dataInicioValidadeImpedimento) {
      const horaAtual = this.dataInicioValidadeImpedimento;
      this.dataInicioValidadeImpedimento = new Date(horaAtual);
      dto.dataInicioValidadeImpedimento = this.dataInicioValidadeImpedimento;
    }
    if (this.codigoTipoOperacao) {
      dto.codigoTipoOperacao = this.codigoTipoOperacao
    }
    if (this.codigoModalidadeOperacao) {
      dto.codigoObjetivoFinanciamento = this.codigoModalidadeOperacao
    }

    if(dto.mascara != null && dto.dataInicioValidadeImpedimento != null) {
      this.service.incluir(this.ideTranche, dto).subscribe(() => {
        this.messageService.addMessage({
          title: 'Sucesso',
          type: 'CRUD_OPERATION',
          level: messageLevel.SUCCESS,
          message: 'Máscara CNAE criada com sucesso'
        });
        this.close();
        this.buscarTodos(false);
      });
    }
    else if(dto.mascara == null && dto.dataInicioValidadeImpedimento == null) {
      this.mensagemAviso = "Os campos 'Máscara' e 'Início da validade de impedimento' devem ser preenchidos."
    }
    else if(dto.mascara == null) {
      this.mensagemAviso = "O campo 'Máscara' deve ser preenchido."
    }
    else if(dto.dataInicioValidadeImpedimento == null) {
      this.mensagemAviso = "O campo 'Início da validade de impedimento' deve ser preenchido."
    }

    if (this.mensagemAviso) {
      setTimeout(() => {
        this.mensagemAviso = ""; 
      }, 5000);
    }
  }

  abrirModal(msg: string, tamanho?: 'sm' | 'md' | 'lg', hasBotoes?: boolean, hasMsgTemplate?: boolean) {
    if (hasBotoes === true && hasMsgTemplate === true) {
      this.modalService.abrir('Cadastro de CNAE impedido de operar', msg, tamanho, this.msgPersonalizada, this.botoesPersonalizados);
    }
  }

  close() {
    this.mascara = null;
    this.dataInicioValidadeImpedimento = null;
    this.codigoTipoOperacao = null;
    this.codigoModalidadeOperacao = null;
    this.modalService.close();
  }

  async abreModalConfirmacao(mensagem: string): Promise<boolean> {
    const titulo = 'Confirmação';

    try {
      const resultadoConfimacao = await this.modalService.abrirConfirm(titulo, mensagem).result;
      return resultadoConfimacao.value === 'ok';
    } catch (e) {
      return false;
    }
  }

  exportarCnaes() {
    this.bnLoadingService.bloqueiaTela();
    const dadosPreenchidos = this.tratarInformacoesPreenchidas();
    this.cnaeService.buscarTodosComFiltro(this.ideTranche, dadosPreenchidos).subscribe((cnae: any) => {
      this.exportService.exportarCnaes(cnae);
    });
  }

}
